import { AddCustomKeyBody } from '@loyalty/shared-common/profile-api-client';
import { Button, Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { CustomKeyForm } from './CustomKeyForm';
import { QlfPlaceholderIcon } from '../../../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { customKeysIcon } from '../../../shared/icons';
import { useCustomKeys } from '../../CustomKeysContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  mainIcon: {
    color: '#BBBBBB',
    marginBottom: spacing(1),
  },
}));

export function CustomKeyDetail() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { createCustomKey, selectedCustomKey, addCustomKey, updateCustomKey } = useCustomKeys();

  const handleSave = async (customKey: AddCustomKeyBody) => {
    if (customKey.isNew) {
      addCustomKey(customKey);
    } else {
      updateCustomKey(customKey.id!, customKey);
    }
  };

  return !selectedCustomKey ? (
    <QlfPlaceholder
      icon={<QlfPlaceholderIcon icon={customKeysIcon} className={classes.mainIcon} />}
      primaryText={t('custom-keys.states.empty.title')}
      secondaryText={t('custom-keys.states.empty.description')}
      actions={
        <Button
          color="primary"
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createCustomKey()}
          sx={{ marginTop: '20px' }}
        >
          {t('custom-keys.states.empty.create-action')}
        </Button>
      }
    />
  ) : (
    <CustomKeyForm key={selectedCustomKey.id} customKey={selectedCustomKey} onSubmit={handleSave} />
  );
}
